import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-351">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-352">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-3xl max-h-[85vh] bg-charcoal border border-gold/20 rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-353">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gold/15 bg-ink/50" data-id="element-354">
              <h2 className="font-serif text-xl md:text-2xl font-bold text-cream" data-id="element-355">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 rounded-full border border-gold/30 text-gold hover:bg-gold/10 transition-colors flex items-center justify-center" data-id="element-356">
                <X className="w-4 h-4" data-id="element-357" />
              </button>
            </div>

            {/* Scrollable content */}
            <div className="overflow-y-auto p-6 md:p-8 text-cream/85 font-light text-sm md:text-base leading-relaxed space-y-4 [&_h3]:font-serif [&_h3]:text-gold [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_strong]:text-cream [&_strong]:font-medium [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_a]:text-gold [&_a]:hover:text-gold-light" data-id="element-358">
              {children}
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-gold/15 bg-ink/50 flex justify-end" data-id="element-359">
              <button onClick={onClose} className="bg-gold hover:bg-gold-light text-ink px-6 py-2 rounded-full font-semibold transition-colors text-sm" data-id="element-360">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}